import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Box';

const CssGrid = styled(Grid)(({ theme }) => ({
   backgroundColor: theme.palette.primary.main,
})
);
export default CssGrid;